import { createSlice } from "@reduxjs/toolkit";
import { getGeneralSuggestions } from "./async-thunks";
import { AccType } from "@src/components/common/filters";

export type GeneralSuggestionsState = {
    autocompleteValues: any; params: AccType; loading: boolean; response: any;
};

const initialState: GeneralSuggestionsState = {
    autocompleteValues: [],
    params: {},
    loading: false,
    response: null
};

export const generalSuggestionSlice = createSlice({
    name: "general-suggestions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getGeneralSuggestions.fulfilled, (state, action) => {
            state.loading = false;
            state.autocompleteValues = action.payload.data;
            state.params = action.payload.params;
        });
        builder.addCase(getGeneralSuggestions.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getGeneralSuggestions.rejected, (state) => {
            state.loading = false;
        });
    }
});

export const generalSuggestionsReducer = generalSuggestionSlice.reducer;